export default {
  CITY: `City`,
  COUNTRY: `Country`,
  FLOOR: `Floor`,
  ROOM: `Room/Apartment`,
  STREET_ADDRESS: `Street Address`,
  STATE: `State`,
  ZIP_CODE: `Zip code`,
  SEARCH_FOR_AN_ADDRESS: `Search for an address`,
  ADD_AN_ADDRESS: `Add address`,
  START_TAPPING_TO_SEARCH: `Start typing to search`,
  ADDRESS: `Address:`,
  ADD: `Add`,
  NO_ADDRESS_ENTERED: `No address entered`,
  EDIT_ADDRESS: `Edit address`,
  CANCEL: `Cancel`,
  UPDATE: `Update`,
  GEOFENCE_RADIUS: `Geofence radius`
}
